/* Olivia & Jack cart display timer.
   A recurring visual 10-minute clock, NOT a stock reservation/offer expiry.
   Uses a timestamp so background tabs don't drift; it changes no cart state. */
(() => {
  'use strict';
  const DURATION = 10 * 60 * 1000;
  const KEY = 'oj-cart-clock-start-v2';
  let start = Date.now();
  try {
    const saved = Number(sessionStorage.getItem(KEY));
    if (Number.isFinite(saved) && saved > 0 && saved <= start) start = saved;
    else sessionStorage.setItem(KEY, String(start));
  } catch (_) { /* storage disabled: timer still works in this tab */ }
  function update() {
    const target = document.querySelector('#cart-drawer [data-oj-cart-timer]');
    if (!target) return;
    const elapsed = Math.max(0, Date.now() - start);
    // Include 00:00 for one second before the visual clock starts again.
    const elapsedSeconds = Math.floor(elapsed / 1000);
    const secs = 600 - (elapsedSeconds % 601);
    const display = String(Math.floor(secs / 60)).padStart(2, '0') + ':' +
                    String(secs % 60).padStart(2, '0');
    if (target.textContent !== display) target.textContent = display;
  }
  function init() { update(); setInterval(update, 1000); document.addEventListener('visibilitychange', update); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
